import { render } from "./RevisarCrossdockingClientesPage.vue?vue&type=template&id=53323994&scoped=true"
import script from "./RevisarCrossdockingClientesPage.vue?vue&type=script&lang=js"
export * from "./RevisarCrossdockingClientesPage.vue?vue&type=script&lang=js"

import "./RevisarCrossdockingClientesPage.vue?vue&type=style&index=0&id=53323994&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\eric.aparicio\\Documents\\REPOS\\ubiku.2023-master\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53323994"]])

export default __exports__